import type { ApprovalLevelApproverResponse } from 'mmfintech-backend-api/types'
import { joinStrings } from 'mmfintech-commons'

type FindApproverOutput = ApprovalLevelApproverResponse | null
type LevelApprovers = Record<number, ApprovalLevelApproverResponse[]>

export const findApproverByRole = (roles: string | string[], data: LevelApprovers): FindApproverOutput => {
  if (data) {
    // iterate over the data to check each array of approvers
    for (const level in data) {
      // iterate over each approver object in the array
      for (const approver of data?.[level] || []) {
        if (
          (typeof roles === 'string' && roles === approver?.customerRole) ||
          (Array.isArray(roles) && roles.includes(approver?.customerRole))
        ) {
          return approver
        }
      }
    }
  }

  return null
}

export const findApproverByName = (name: string, data: LevelApprovers): FindApproverOutput => {
  if (data) {
    // Iterate over the data to check each array of approvers
    for (const level in data) {
      // Iterate over each approver object in the array
      for (const approver of data?.[level] || []) {
        const approverName = joinStrings([approver?.firstName, approver?.lastName], ' ')
        if (approverName === name) {
          return approver
        }
      }
    }
  }

  return null
}
